import type { ImageProps as NextImageProperties } from "next/image";
import NextImage from "next/image";

type ImageSource = string | { src: string };

interface ImageProperties extends Omit<NextImageProperties, "src"> {
  src: ImageSource;
  placeholder?: "blur" | "empty";
  blurDataURL?: string;
}

export const Image = ({
  src,
  alt,
  placeholder = "empty",
  blurDataURL,
  ...props
}: ImageProperties) => {
  const normalizedSrc = typeof src === "string" ? src : src?.src;


  return (
    <NextImage
      src={normalizedSrc}
      alt={alt}
      placeholder={placeholder}
      blurDataURL={blurDataURL}
      {...props}
    />
  );
};

export type { ImageProperties as ImageProps };
